"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    drawer: _defineProperty({
      width: 290
    }, theme.breakpoints.up('lg'), {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }),
    root: {
      backgroundColor: theme.palette.white,
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    divider: {
      margin: theme.spacing(1, 0)
    },
    nav: {
      marginBottom: theme.spacing(2)
    }
  };
};

var _default = styles;
exports.default = _default;